import { GridFilterItem } from "@mui/x-data-grid-pro"; // Replace with the correct module path

export const appliedFiltersCounter = (filterModelItems: GridFilterItem[]) =>
  filterModelItems.reduce((acc: number, item) => {
    if (item.value) {
      return acc + 1;
    }
    return acc;
  }, 0);
